<template>
  <v-dialog 
    :value="value"
    fullscreen 
    hide-overlay 
    transition="slide-y-reverse-transition"
  >
    <v-sheet
      max-height="100%"
      class="stories sheet fill-height"
      v-visibility-change="visibilityChange"
      v-touch="{ down: () => { if (skipable) close() } }"
    >
      <v-toolbar 
        absolute
        dark
        width="100vw"
        color="transparent"
        elevation="0"
        class="header"
        style="z-index: 3;"
      >
        <v-progress-linear
          v-for="(item, i) in items"
          :key="'progress-'+i"
          :value="controller.items[i].time"
          :class="['bar mx-1 mb-4', { active: current==i }]"
          color="primary"
          background-color="white"
          background-opacity=".24"
          @click="select(i)"
        />
        <p class="title text-body-2">
          {{ story?.title }}
        </p>
        <div class="fade" />
      </v-toolbar>
      <!-- <v-btn
        v-if="seen||seenAll"
        absolute
        top
        right
        fab
        icon
        color="white"
        class="mt-12 mr-n4"
        @click="toggleView(false)"
      >
        <v-icon>{{ icons.close }}</v-icon>
      </v-btn> -->
      <v-carousel 
        :value="current"
        height="100vh"
        :show-arrows="false"
        :hide-delimiters="true"
        touchless
        class="track"
        @change="onStoryChange"
      >
        <v-carousel-item 
          v-for="(item,i) in controller.items"
          :key="'story-'+i"
          class="fill-height"
        >
          <video 
            v-if="item.type=='video'"
            :ref="'video-'+i" 
            :playsinline="true"
            class="story fill-height"
            @timeupdate="onTimeUpdate(i)"
            @loadedmetadata="onLoadMedia(i)"
          >
            <source :src="item.url" :type="item.format" />
            <!-- <track
              v-if="item.vtt"
              label="caption"
              kind="captions"
              :srclang="$i18n.locale"
              :src="item.vtt"
              default 
            /> -->
          </video>
          <div
            v-else-if="item.type=='quiz'"
            class="quiz contents d-flex flex-column justify-center"
          >
            <v-window
              v-model="item.question"
              :touchless="item.question+1<item.questions.length"
              class="quiz-container"
            >
              <v-window-item
                v-for="(question, q) in item.questions"
                :key="`quiz-${i}-${q}`"
                :value="q"
                :class="['question px-6', { answered: question.answer!=null }]"
              >
                <div 
                  class="text primary--text"
                >
                  <p 
                    class="question text-h4 font-weight-bold mb-10" 
                    v-html="formatText(question.text)"
                  />
                  <v-card 
                    v-for="(option, o) in question.options"
                    :key="`quiz-${i}-${q}-${o}`"
                    outlined
                    :class="['option mb-4', { correct: option.correct, selected: question.answer==o }]"
                    @click="answer(i, q, o)"
                  >
                    <v-card-text
                      class="text text-body-1 white--text font-weight-medium"
                      v-html="formatText(option.text)"
                    />
                  </v-card>
                </div>
              </v-window-item>
            </v-window>
          </div>
          <div 
            v-if="current==i&&(story.type=='video'&&story.content)"
            class="contents"
          >
            <div
              v-for="(content, c) in story.content"
              :key="'content-'+c"
              :class="['content', content.type, content.position, content.fit]"
            >
              <div 
                v-if="content.type=='text'" 
                class="text primary--text"
              >
                <p 
                  v-for="(line) in content.text"
                  class="line" 
                  v-html="formatText(line)"
                />
              </div>
              <div 
                v-else-if="content.type=='subtitle'" 
                class="text text-center"
              >
                <span
                  v-for="(line) in content.text"
                  class="line" 
                  v-html="formatText(line)"
                />
              </div>
              <img 
                v-else-if="content.type=='image'"
                :src="content.url"
              />
              <video 
                v-else-if="content.type=='video'"
                :ref="'content-video-'+content.start"
                :src="content.url" 
                :playsinline="true"
                :autoplay="controller.playing"
                muted
                class="story fill-height"
                @loadedmetadata="onLoadMedia(i, content)"
              />
            </div>
          </div>
        </v-carousel-item>
        <v-overlay
          :value="story?.type=='video'"
          absolute
          :opacity="controller.playing ? 0 : .64"
          z-index="1"
          class="overlay"
          @click="pause()"
        >
          <div 
            class="control previous" 
            @click.stop="back" 
          />
          <div 
            v-if="current+1<=start||skipable"
            class="control next" 
            @click.stop="select(current+1)" 
          />
          <div class="overlay-content d-flex justify-center align-center">
            <v-fab-transition>
              <v-btn
                v-show="!controller.playing"
                fab
                x-large
                color="secondary darken-2"
                class="btn play"
                @click.stop="pause(false)"
              >
                <v-icon>{{ icons.play }}</v-icon>
              </v-btn>
            </v-fab-transition>
          </div>
        </v-overlay>
      </v-carousel>
      <v-fab-transition>
        <v-btn
          v-show="items.length-1==current||(skipable&&!controller.playing)"
          color="primary"
          dark
          absolute
          bottom
          right
          fab
          class="btn done mr-4 mb-16 black--text"
          @click.stop="close()"
        >
          <v-icon class="icon">
            {{ icons.check }}
          </v-icon>
        </v-btn>
      </v-fab-transition>
    </v-sheet>
  </v-dialog>
</template>

<style lang="scss">

  #app .v-dialog .stories.sheet {
    position: relative;
    height: 100% !important;
    padding-top: 0 !important;

    .header {
      height: auto !important;
      .v-toolbar__content {
        padding-top: var(--safe-area-top);
        height: calc(56px + var(--safe-area-top)) !important;
      }

      .bar {
        position: relative;
        z-index: 2;
      }
      .fade {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 200%;
        background: linear-gradient(180deg, var(--v-background-base) 20%, rgba(0,0,0,0) 100%);
        opacity: .64;
      }
      .title {
        position: absolute;
        top: calc(3rem + var(--safe-area-top));
        left: 1.25rem;
        right: 1.25rem;
        margin: 0;
        z-index: 2;
        text-shadow: 1px 1px 3px var(--v-background-base);
      }
    }

    .quiz {
      .answered .option {
        &.selected {
          color: var(--v-error-base);
          border-color: var(--v-error-base);
          &:not(.correct) {
            animation: wobble 0.5s ease;
          }
        }
        &.selected.correct {
          --color: var(--v-success-base);
          animation: grow-glow 1s ease;
          background-color: var(--v-success-base) !important;
          border-color: var(--v-success-base) !important;
          .text {
            color: var(--v-background-base) !important;
          }
        }
      }
    }

    .contents {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      .content {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 100%;
        max-height: none !important;
        z-index: 1;
        &.text, &.subtitle {
          z-index: 3;
          display: flex;
          align-items: end;
          justify-content: start;
          padding: 1.5rem;
          padding-bottom: 8rem;
          color: white;
          font-size: 2.5rem;
          line-height: 1.4;
          font-weight: 500;
          .line {
            margin-bottom: .5rem;
          }
          em {
            background-color: var(--v-background-base);
            font-style: normal;
          }
        }
        &.subtitle {
          justify-content: center;
          padding-bottom: 2rem;
          color: white;
          font-size: 1.25rem;
          font-family: "Roboto", sans-serif;
          font-weight: 500;
          line-height: 1.5;
          .text {
            // background-color: var(--v-background-base);
            text-shadow: 1px 1px 3px var(--v-background-base);
          }
        }
        &.image, &.video {
          background-color: var(--v-background-base);
        }
        &.image {
          z-index: 2;
        }
        img, video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &.top {
          img, video {
            object-position: top;
          }
          &.offset-20 {
            img, video {
              padding-top: 20vh;
            }
          }
          &.offset-25 {
            img, video {
              padding-top: 25vh;
            }
          }
          &.offset-30 {
            img, video {
              padding-top: 25vh;
            }
          }
        }
        &.bottom {
          img, video {
            object-position: bottom;
          }
          &.offset-20 {
            img, video {
              padding-bottom: 20vh;
            }
          }
          &.offset-25 {
            img, video {
              padding-bottom: 25vh;
            }
          }
          &.offset-30 {
            img, video {
              padding-bottom: 25vh;
            }
          }
        }
        &.contain {
          img, video {
            object-fit: contain;
          }
        }
      }
    }

    .overlay {
      .overlay-content {
        width: 100dvw;
        height: 100dvh;
      }
      .control {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 20%;
        &.previous {
          left: 0;
        }
        &.next {
          right: 0;
        }
      }
    }
    video::cue {
      background-color: var(--v-background-base);
      color: white;
      font-size: 1.25rem;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      line-height: 1.5;
      text-shadow: 1px 1px 3px var(--v-background-base);
    }
  }

  .stories .track {
    position: relative;
  }
  
  .stories .story {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

</style>

<script>

  // Icons
  import {
    mdiClose,
    mdiChevronDown,
    mdiChevronUp,
    mdiChevronRight,
    mdiPlay,
    mdiPause,
    mdiCheck
  } from '@mdi/js'

  // Utilities
  import _ from 'lodash';
  import services from '@/services'

  export default {
    name: 'MStories',

    props: {
      value: {
        type: Boolean,
        default: false,
      },
      items: {
        type: Array,
        default: () => [],
      },
      start: {
        type: Number,
        default: 0,
      },
      skipable: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      icons: {
        close: mdiClose,
        down: mdiChevronDown,
        up: mdiChevronUp,
        right: mdiChevronRight,
        play: mdiPlay,
        pause: mdiPause,
        check: mdiCheck,
      },
      current: 0,
      controller: {
        items: [],
        started: false,
        playing: false,
      },
      // subtitles: {
      //   toggle: false
      // }
    }),

    computed: {
      story () {
        const items = this.controller.items || [];
        const current = this.current;
        const story = current in items ? _.cloneDeep(items[current]) : null;
        if (story) {
          const time = (story.time/100) * story.duration || 0;
          story.content = _.filter(story.content, (c) => {
            return time>=c.start&&time<=c.end
          });
          // console.log('content story', time, story.content);
        }
        return story;
      }
    },

    watch: {
      value (b) {
        if (b) this.current = this.start;
        // const i = this.current;
        // if (b
        //   &&_.has(this.$refs, 'video-'+i)
        //   &&this.$refs['video-'+i][0].paused) this.pause(false);
      },
      items: {
        immediate: true,
        deep: true,
        handler (items) {
          if (!items) return;
          this.controller.items = _.map(_.cloneDeep(items), (item, i) => {
            if (item.type=='quiz') {
              item.question = 0;
              _.each(item.questions, question => {
                question.answer = null;
              })
            }
            return {
              ...item,
              index: i,
              duration: item.duration,
              vtt: item.vtt || null,
              content: this.parseContent(item.content || []),
              time: i<this.start ? 100 : 0,
              seen: i<this.start,
            }
          });
          this.controller.width = items.length / 100;
          this.current = this.start;
        }
      },
      current (i) {
        const item = this.controller.items[i];
        if (item&&item.srt&&!item.vtt) {
          this.subtitles(i, item);
        }
      }
    },

    methods: {
      ...services,

      onTimeUpdate (i) {
        const item = this.controller.items[i];
        if (this.current==i&&_.has(this.$refs, 'video-'+i)) {
          const t = this.$refs['video-'+i][0].currentTime;
          const time = (t / item.duration) * 100;
          this.controller.items[i].time = time;
          if (time>=100) {
            this.select(this.current+1, true);
          }else if (time>=70) {
            this.$emit('seen', i);
          }
        }
      },

      back () {
        const video = this.$refs['video-'+this.current][0];
        if (video&&video.currentTime>3) {
          this.pause(false, true);
        }else{
          this.select(this.current-1);
        }
      },

      select (i, skip=false, intended=true) {
        if (!this.value&&(!this.skipable&&!skip&&i>this.start)) return;
        if (i<0) {
          i = 0;
        }else if (i>=this.controller.items.length) {
          // this.$emit('seen', i);
          this.close();
          return;
        }
        console.log('select story', i);
        // pause current
        this.pause(true, true, false);
        _.each(this.controller.items, (item, j) => {
          if (j<i) {
            item.time = 100;
          }else{
            item.time = 0;
          }
        })
        this.controller.items[i].seen = true;
        this.current = i;
        setTimeout(() => {
          this.pause(false, true, intended);
        }, 250);
        // if (i>0) this.$emit('seen', i-1);
      },

      pause (b=null, reset=false, intended=true) {
        const i = this.current;
        b = b===null ? this.controller.playing : b;
        if (!this.controller.started&&intended) this.controller.started = true;
        if (_.has(this.$refs, 'video-'+i)) {
          const video = this.$refs['video-'+i][0];
          if (b) {
            video.pause();
            if (intended) this.controller.playing = false;
          }else{
            video.currentTime = reset ? 0 : video.currentTime-1;
            video.play();
            if (intended) this.controller.playing = true;
          }
          if (_.some(this.story.content, { type: 'video' })) {
            // pause content videos too
            _.each(_.filter(this.story.content, { type: 'video' }), (content) => {
              if (_.has(this.$refs, 'content-video-'+content.start)) {
                this.$refs['content-video-'+content.start][0][b ? 'pause' : 'play']();
              }
            });
          }
        }
      },

      answer (index, question, option) {
        const story = this.controller.items[index];
        story.questions[question].answer = option;
        if (story.questions[question].options[option].correct) {
          setTimeout(() => {
            if (story.questions.length>question+1) {
              story.question += 1;
            }else{
              this.select(this.current+1);
            }
          }, 1250);
        }
      },

      onStoryChange (i) {
        console.log('changed story', i);
      },

      onLoadMedia (i, content=null) {
        if (content&&content.offset) {
          console.log(content.offset);
          
          if (_.has(this.$refs, 'content-video-'+content.start)) {
            this.$refs['content-video-'+content.start][0].currentTime = this.timeStringToSeconds(content.offset);
          }
        }else{
          this.controller.items[i].duration = this.$refs['video-'+i][0].duration;
          this.$nextTick(() => {
            if (this.controller.started) this.$refs['video-'+i][0].play();
          });
        }
      },

      subtitles (i, item) {
        const convert = (srt) => {
          // Add "WEBVTT" header and replace commas with dots in timestamps
          return "WEBVTT\n\n" + srt
            .replace(/\r+/g, '')                // remove \r
            .replace(/^\d+\s*$/gm, '')           // remove cue numbers
            .replace(/(\d+:\d+:\d+),(\d+)/g, '$1.$2') // fix timestamp commas
            .trim();
        }
        fetch(`${item.srt}?t=${Date.now()}`).then(async(response) => {
          const srt = await response.text();
          const vtt = convert(srt);
          const blob = new Blob([vtt], { type: 'text/vtt' });
          item.vtt = URL.createObjectURL(blob);
          item.content = [...item.content, ...this.parseContent(this.srtToContent(srt))];
        }).catch((e) => {
          console.error('error loading subtitles', i, item.title, e);
        });
      },

      srtToContent (srtText) {
        const lines = srtText.trim().split(/\r?\n/);
        const result = [];
        let i = 0;

        while (i < lines.length) {
          // Skip index line (like "1", "2", etc.)
          if (/^\d+$/.test(lines[i])) {
            i++;
          }

          // Time line
          const timeLine = lines[i++];
          if (!timeLine) continue;

          const textLines = [];
          while (i < lines.length && lines[i].trim() !== "") {
            textLines.push(lines[i++]);
          }

          // Skip empty separator line
          i++;

          result.push({
            type: "subtitle",
            time: timeLine.trim(), // keeps original "00:00:12,000 --> 00:00:16,000"
            text: textLines.join(" \n ")
          });
        }

        return result;
      },

      parseContent (content) {
        return content.map(item => {
          const { start, end } = this.parseTimeRange(item.time||'0');
          if (item.type=='text') {
            if (_.isString(item.text)) item.text = [item.text];
            item.text = item.text.map(line => {
              return `**${line}**`;
            });
          }else if (item.type=='subtitle') {
            item.text = item.text.split('\n').map(line => {
              return `**${line}**`;
            });
          }
          return { ...item, start, end };
        });
      },

      parseTimeRange (rangeStr) {
        const [startStr, endStr='10:00:00,000'] = rangeStr.split('-->').map(s => s.trim());
        return {
          start: this.timeStringToSeconds(startStr),
          end: this.timeStringToSeconds(endStr)
        };
      },

      timeStringToSeconds (timeStr) {
        // SRT uses comma for milliseconds, replace with dot
        const [h=0, m=0, s=0] = timeStr.replace(',', '.').split(':');
        return parseInt(h) * 3600 + parseInt(m) * 60 + parseFloat(s);
      },

      close () {
        this.pause(true, true);
        this.$emit('close', this.current);
      },


      visibilityChange (evt, hidden) {
        // check status
        if (this.value) {
          if (hidden) {
            this.pause(true, false, false);
          }else{
            if (this.controller.playing) this.pause(false, false, false);
          }
        }
      },
    },

    mounted () {

    },

  }
</script>
